/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseHub } from '../../models/api-response-hub';
import { Hub } from '../../models/hub';

export interface CreateHub$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Hub
}

export function createHub(http: HttpClient, rootUrl: string, params: CreateHub$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseHub>> {
  const rb = new RequestBuilder(rootUrl, createHub.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseHub>;
    })
  );
}

createHub.PATH = '/v1/api/hubs';
